import { Box, SxProps } from "@mui/material";
import { FC } from "react";
import APSLogoImage from "../../assets/icons/APS.svg";

const style: SxProps = {
  bgcolor: "#ffffff",
  maxWidth: "md",
};

const APSLogo: FC<{}> = () => {
  return (
    <Box component="img" sx={{ ...style }} alt="APS Logo" src={APSLogoImage} />
  );
};

export default APSLogo;
//APSLogo.whyDidYouRender = true;
